var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFileSearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a8cec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.828,
    stopColor: "#60acef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89c0ef"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_158",
    "data-name": "Group 158",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 40,
    cy: 40,
    r: 40,
    transform: "translate(80 80) rotate(180)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "MDI_file-search",
    "data-name": "MDI / file-search",
    transform: "translate(22.114 23.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Boundary",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.43,
    height: 38.43,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37.43,
    height: 37.43,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_file-search",
    "data-name": "Path / file-search",
    d: "M21.35,2H7.47A3.407,3.407,0,0,0,4,5.34V32.058A3.407,3.407,0,0,0,7.47,35.4H19.615a10.686,10.686,0,0,1-1.978-1.5,10.535,10.535,0,0,1-.625-15.33A11.514,11.514,0,0,1,31.76,17.029v-5.01L21.35,2M19.615,13.689V4.5l9.543,9.184H19.615M32.3,30.221a7.38,7.38,0,0,0-2.429-10.387,8.035,8.035,0,0,0-10.792,2.338,7.369,7.369,0,0,0,2.429,10.387,8.069,8.069,0,0,0,8.311.033l5.413,5.127L37.642,35.4,32.3,30.221m-6.61.167a4.178,4.178,0,1,1,4.338-4.175A4.258,4.258,0,0,1,25.688,30.388Z",
    transform: "translate(-1.923 -0.961)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileSearch);
export default __webpack_public_path__ + "static/media/file-search.6f85c9497d2709c44a83129f62c2a9de.svg";
export { ForwardRef as ReactComponent };